import { Popover, Stack, Typography } from "@mui/material";
import type { BaseSyntheticEvent, MouseEvent, PropsWithChildren } from "react";

interface ItemsListPopoverProps {
  anchorEl: HTMLElement | undefined;
  onClose: (e: BaseSyntheticEvent) => void;
  title?: string | undefined;
}

const ItemsListPopover = ({ anchorEl, onClose, title, children }: PropsWithChildren<ItemsListPopoverProps>) => {
  // React portals bubble events up the React tree, so content clicks would otherwise reach the anchor's grid cell.
  const handleContentClick = (event: MouseEvent<HTMLElement>) => event.stopPropagation();

  return (
    <Popover
      sx={{ mt: 0.5, "& .MuiPaper-root": { minWidth: "max-content" } }}
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Stack spacing={0.5} sx={{ p: 1 }} onClick={handleContentClick}>
        {title && (
          <Typography color="textSecondary" variant="subtitle2">
            {title}
          </Typography>
        )}
        {children}
      </Stack>
    </Popover>
  );
};

export default ItemsListPopover;
